import { V3dTools } from '@/v3d/common';
import { iApp } from '@/Interfaces/app';
import { Camera } from './camera';
import { loader } from '@/Engine/loader';
import { IV3D } from '@/Interfaces/v3d';
import { $ } from '@/Engine/state';
import { gridDivisions, gridEnabled, gridSize } from '@/Constants/3dConfig';
import { testJSON, testJSON2 } from '@/Constants/testJSON';
import { Locker } from '@/Engine/Locker';
import { iApi } from '@/Engine/apiInterfaces';
import { modelNames } from '@/Constants/modelMeta';
import { Vector3 } from 'three';


declare let v3d: IV3D;
export const app = async function(app: iApp) {
    $.app = app;
    $.textureLoader = new v3d.TextureLoader();
    // app.controls.enableRotate = true;
    // app.controls.enablePan = true;
    // app.controls.enableKeys = true;
    app.hideFPS();
    app.disableRendering(0);
    const version = 'v1.1.3';
    console.log(version);
    await loader(`lockers.gltf.xz?${version}.xz`, (scene) => {
            scene.traverse((item) => {
                item.visible = false;
            });
            modelNames.forEach((modelName) => {
                const model = scene.getObjectByName(modelName);
                if (model)
                    model.visible = false;
            });
        }, (progress) => {
            if (progress === 100) return;
            window.parent.postMessage({ configurator: {
                    action: 'progress',
                    payLoad: {
                        progress,
                    },
                } }, '*');
            // console.log(progress);
        },
        app,
    );

    // app.render();
    const render = (cb?: () => void) => requestAnimationFrame(() => {
        app.render();
        if (cb) cb();
    });

    $.render = render;
    const v3dTools = new V3dTools(app);
    $.v3dTools = v3dTools;
    // const vergeConfig = useVergeConfig();

    // await loader('wardrobe.gltf.xz', (scene) => {
    //         scene.children.forEach((item) => {
    //             item.visible = false;
    //         });
    //     }, (progress) => {
    //
    //     },
    //     app,
    // );

    const camera = new Camera(app.getCamera(), v3dTools);

    if (gridEnabled) {
        $.grid = new v3d.GridHelper(gridSize, gridDivisions);
        app.scene.add($.grid);
    }


    const containerParent = document.getElementById('v3d-container') as HTMLElement;
    $.container = containerParent;
    $.camera = camera;

    // camera.topCamMode(true);


    // document.addEventListener('keyup', (e)=>{
    //     if (e.key === 'Escape') {
    //         selectionBox.unselect();
    //         $.render();
    //     }
    // });
    // $.container.addEventListener('pointermove', onPointerMove);
    // $.container.addEventListener('pointerdown', onDownHandler);
    // $.container.addEventListener('pointerup', onPointerUpHandler);
    // $.container.addEventListener('drop', onDropHandler);
    // $.container.addEventListener('dragover', onDragOverHandler);
    window.addEventListener('resize', () => {
        $.render();
    });
    app.controls.addEventListener('change', () => {
        $.render();
    });

    const updateCamPos = () => {
        // app.camera.position.y = 1;
        // TODO требуется высчитывать позицию камеры относительно локера
        // TODO также ожидаем, что будут присылать активные локер
        $.camera.updateCam(
            {
                x: 1,
                y: 1,
                z: -0.2,
            },
            {
                x: 1,
                y: 2,
                z: 4,
            },
        );
        $.render();
    };

    const  takeScreenshot = async() => {
        // console.log(app.scene.background)
        $.defaultBackground = app.scene.background;
        if ($.grid) {
            $.grid.removeFromParent();
        }
        const canvas = document.getElementsByClassName('v3d-canvas')[0] as HTMLCanvasElement;
        $.app.camera.aspect = 1;
        $.app.camera.updateProjectionMatrix();
        $.app.renderer.setSize(400, 400);
        // $.app.renderer.setAspect(1);
        app.scene.background = new v3d.Color('#ffffff');

        const screenshots = [];
        for (let i = 0; i < $.lockers.length; i++) {
            // console.log($.lockers[i].center);
            $.lockers.forEach((locker, i) => {
                locker.hideWalls();
                locker.model.removeFromParent();
            });
            $.lockers[i].closeDoors();
            // TODO костыль, открыте и закрыте дверей надо делать через await
            await sleep(1000);
            $.app.scene.add($.lockers[i].model);
            await moveCameraForScreenshot($.lockers[i].center, $.lockers[i].cameraPosition);
            const screenshot1 = canvas.toDataURL('image/jpeg');
            $.lockers[i].openDoors();
            await sleep(1000);
            $.render();
            const screenshot2 = canvas.toDataURL('image/jpeg');
            screenshots.push([ screenshot1, screenshot2 ]);
        }
        window.parent.postMessage({ configurator: {
                action: 'sendScreenshots',
                payLoad: {
                    screenShots: screenshots,
                },
            } }, '*');
        $.app.camera.aspect = $.container.offsetWidth/$.container.offsetHeight;
        $.app.camera.updateProjectionMatrix();
        $.app.renderer.setSize($.container.offsetWidth , $.container.offsetHeight);
        $.lockers.forEach((locker, i) => {
            $.app.scene.add($.lockers[i].model);
        });
        app.scene.background = $.defaultBackground;
        if (gridEnabled) {
            app.scene.add($.grid);
        }


        $.render();
    };

    // window.takeScreenshot = takeScreenshot;

    const sleep = async(time: number) => {
        return new Promise((resolve)=>{
            setTimeout(()=>{
                $.render(()=>{
                    resolve(null);
                });
            }, time);
        });
    };

    const moveCameraForScreenshot = (target: Vector3, position: Vector3) => {
        return new Promise((resolve)=>{
            //TODO высчитывать позицию камеры
            $.camera.updateCam(
                target,
                position,
            );
            setTimeout(()=>{
                $.render(()=>{
                    resolve(null);
                });
            }, 50);
        });
    };

    // $.floor = v3dTools.getObjectByName('floor ');
    // console.log($.app.scene.getObjectByName('floor '));
    // console.log($.floor)
    // console.log($.app.scene.children)
    // if ($.floor) {
    //     $.floor.material.envMapIntensity = 0.3;
    //     $.floor.material.reflectivity = 0;
    // }

    interface iDimension {
        width: number;
        depth: number;
    }

    const clearTest = () => {
        $.lockers.forEach((locker) => {
            locker.destroy();
        });
        $.lockers = [];
        $.render();
    };

    // const loadTest = () => {
    //     clearTest();
    //     let allWidth = 0;
    //     const gap = 0.5;
    //     testJSON2.lockers.forEach((locker, index) => {
    //         const lockerItem = new Locker(locker);
    //         lockerItem.model.position.x += allWidth + index * gap;
    //         allWidth += lockerItem.width;
    //         $.app.scene.add(lockerItem.model);
    //         $.lockers.push(lockerItem);
    //     });
    //     updateCamPos();
    //     $.render();
    // };


    let firstMessage = true;
    const onMessageHandler = (message: any) => {
        if (!message.data || !message.data.configurator) return;


        if (message.data.configurator.action === 'update') {
            const data = message.data.configurator.payLoad.data as iApi;
            console.log(data);
            $.lockers.forEach((locker) => {
                locker.destroy();
            });
            $.lockers = [];
            let allWidth = 0;
            const gap = 0.5;
            data.lockers.forEach((locker, index) => {
                const lockerItem = new Locker(locker);
                lockerItem.model.position.x += allWidth + index * gap;
                allWidth += lockerItem.width;
                $.app.scene.add(lockerItem.model);
                $.lockers.push(lockerItem);
            });
            // app.controls.
            // updateCamPos();
            $.render();
            if (firstMessage) {
                $.camera.updateCam(
                    $.lockers[0].center,
                    $.lockers[0].cameraPosition,
                    1,
                );
                firstMessage = false;
            }

        }

        if (message.data.configurator.action === 'screenshots') {
            takeScreenshot();
        }

        if (message.data.configurator.action === 'lockerSelect') {
            const index = message.data.configurator.payLoad.index;
            if (!$.lockers[index]) return;

            $.camera.updateCam(
                $.lockers[index].center,
                $.lockers[index].cameraPosition,
                1,
            );
        }
    };

    const inIframe = () => window.self !== window.top;
    if (!inIframe()) {
        setTimeout(()=>{
            onMessageHandler(testJSON2);
        }, 300);

    }

    window.addEventListener('message', onMessageHandler,false);


    updateCamPos();
    $.render();
    setTimeout(()=>{
        window.parent.postMessage({ configurator: {
                action: 'progress',
                payLoad: {
                    progress: 100,
                },
            } }, '*');
    }, 100);
};
